import moment from 'moment';

export const formatResourceDate = resource =>
  resource.creation_date ? moment(resource.creation_date).format('MMMM D') : '';
